import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { IconWithDefaults } from '../Icon';
import colors from '../Theme/colors';

const openInNewIconProperties = {
  title: PropTypes.string,
  fillColor: PropTypes.string,
  size: PropTypes.number,
};

type OpenInNewIconProperties = InferProps<typeof openInNewIconProperties> & {
  size?: number;
  fillColor?: string;
};
// eslint-disable-next-line max-len
const dPath = 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z';

const OpenInNewIcon = ({
  title,
  fillColor,
  size,
}: OpenInNewIconProperties) => (
  <IconWithDefaults
    dPath={dPath}
    title={title ?? 'Open in new window'}
    width={size ?? 24}
    height={size ?? 24}
    fill={fillColor ?? colors.greyDark}
  />
);

OpenInNewIcon.propTypes = openInNewIconProperties;

export default OpenInNewIcon;
